import React, { FC, ReactElement, useEffect, useState } from 'react';
import cns from 'classnames';
import './Speakers.sass';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getContentDataSpeakers, getScheduleStreams } from '../../../../stores/reducers/userData';
import routes from '../../../../config/routes';
import { getSpeakers } from '../../../../helpers/speakers';
import { ParamsDto, internalizationState } from '../../../../stores/reducers/sections';
import { declOfNum } from '../../../../helpers/decl';
import SpeakerQuestionModal from '../../../Modals/SpeakerQuestionModal/SpeakerQuestionModal';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import Default from './SpeakersViews/DefaultView';
import Horizontal from './SpeakersViews/HorizontalView';
import Columns from './SpeakersViews/ColumnsView';
import Cards from './SpeakersViews/CardsView';
import './SpeakersViews/speakers.views.sass';
interface Props {
  className?: string;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName: string;
  sectionId: string;  
  sectionData?: Array<ParamsDto>;
}

const Speakers: FC<Props> = ({ className, bgSettings, sectionName, sectionId, sectionData }): ReactElement => {
  const { allowTargetBeforeStart, ...subtitles } = useSelector(getContentDataSpeakers);
  const streams = useSelector(getScheduleStreams);
  const [speakers, setSpeakers] = useState<any>({});
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [questionRecepient, setQuestionRecepient] = useState<string>('');
  const [blockSpeakerViewParams, setBlockSpeakerViewParams] = useState<ParamsDto>();
  const [speakerViewParams, setspeakerViewParams] = useState<ParamsDto[]>();

  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    speakersCountTitle_ru: ['Спикер', 'Спикера', 'Спикеров'],
    speakersCountTitle_en: ['Speaker', 'Speaker', 'Speakers'],
    allSpeakersRu: 'Все спикеры',
    allSpeakersEn: 'All speakers',
    askQuestion_ru: 'Задать вопрос',
    askQuestion_en: 'Ask a Question',
  };

  const localizedName = (field: string): string | string[] => localeFieldResolver(localizeData, field, activeLangState);

  const openQuestionModal = (subtitle?: any): void => {
    setQuestionRecepient(subtitle);
    setIsModalOpen(true);
  };

  const isSubstrateGradientVisible = (): boolean => {
    const gradientVisibiliteParam = sectionData!.find((param) => param.className === 'is-gradient-visible');
    return gradientVisibiliteParam && 'checked' in gradientVisibiliteParam ? gradientVisibiliteParam.checked as boolean : true;
  };

  const getSubstrateBackgound = () => {
    let result = {};
    if (!isSubstrateGradientVisible()) {
      const substrateBackgoundData = sectionData!.find((param) => param.type === 'speakersSubstrateBackgound');
      if (substrateBackgoundData) {
        result = {
          background: substrateBackgoundData.value,
        };
      }
    }
    return result;
  };

  const isSpeakersVisible = (): boolean => {
    const speakersVisibiliteParam = sectionData!.find((param) => param.className === 'is-speakers-visible');
    return speakersVisibiliteParam && 'checked' in speakersVisibiliteParam ? speakersVisibiliteParam.checked as boolean : true;
  };

  const isSpeakersBlockDisabled = (): boolean => {
    const speakersDisableParam = sectionData!.find((param) => param.key === 'disableSpeakers');
    return typeof speakersDisableParam !== 'undefined' && (speakersDisableParam.checked as boolean);
  };

  const substrateBackgound = getSubstrateBackgound();

  const substrateText = sectionData!.find((param) => param.type === 'speakersSubstrateText');
  const substrateButtonBackground = sectionData!.find((param) => param.type === 'speakersSubstrateButtonBackgound');
  const substrateButtonText = sectionData!.find((param) => param.type === 'speakersSubstrateButtonText');
  let speakersCnt = 0;
  let speakersPlusSing = '';

  if (speakers && speakers.length) {
    speakersCnt = speakers.length;
    if (speakers.length > 10) {
      speakersCnt = Math.trunc(speakers.length / 10) * 10;
      speakersPlusSing = '+';
    }
  }

  useEffect(() => {
    setSpeakers(getSpeakers(streams));
  }, [streams]);

  useEffect(() => {
    const speakerViewsParams = sectionData?.find((param) => param.key === 'blockSpeakerViewType');
    setBlockSpeakerViewParams(speakerViewsParams);
    const params = sectionData?.filter((param) => {
      return param.parent === blockSpeakerViewParams?.key && param.isParentValue === blockSpeakerViewParams?.value;
    });
    setspeakerViewParams(params);
  }, [sectionData, blockSpeakerViewParams]);

  const speakersViewTemplate = () => {
    switch (blockSpeakerViewParams?.value) {
      case 'Horizontal':
        return <Horizontal speakers={speakers} viewParams={speakerViewParams} />;
      case 'Columns':
        return <Columns speakers={speakers} />;
      case 'Cards':
        return <Cards speakers={speakers} viewParams={speakerViewParams} />;
      default:
        return <Default speakers={speakers} allowTargetBeforeStart={allowTargetBeforeStart} questionModalhandler={(name: string) => openQuestionModal(name)} />;
    }
  };

  return (
    <section
      className={cns(
        'inner-section',
        'speakers-section',
        bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        className
      )}
      style={{ backgroundColor: bgSettings && bgSettings.color }}>
      <div className="container" id={sectionId}>
        <div className="inner-section__head">
          <div className="section-title">{sectionName}</div>
          <p className="user-fs-text">{localeFieldResolver(subtitles, 'speakerSubtitle', activeLangState)}</p>
        </div>
        {speakersViewTemplate()}
        {!isSpeakersBlockDisabled() &&
          <div className="all-speakers-btn" style={{ ...substrateBackgound }}>
            <div className="all-speakers-btn-inner">
              {isSpeakersVisible() &&
                <div className="all-peakers-btn-text f-heading" style={{color: substrateText && substrateText.value}}>
                  {speakersCnt + speakersPlusSing}
                  <span>{declOfNum(speakersCnt, localizedName('speakersCountTitle_ru') as Array<string>)}</span>
                </div>
              }
              <Link
                className="btn btn--md btn-primary"
                to={routes.SPEAKERS}
                style={{
                  backgroundColor: substrateButtonBackground && substrateButtonBackground.value,
                  color: substrateButtonText && substrateButtonText.value,
                  width: !isSpeakersVisible() ? '100%' : '',
                }}>
                {localizedName('allSpeakersRu')}
              </Link>
            </div>
          </div>
        }
      </div>
      <SpeakerQuestionModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        recepient={questionRecepient || ''}
      />
    </section>
  );
};

export default Speakers;
